import { render, staticRenderFns } from "./RoomScreen.vue?vue&type=template&id=7b40648e&scoped=true&"
import script from "./RoomScreen.vue?vue&type=script&lang=js&"
export * from "./RoomScreen.vue?vue&type=script&lang=js&"
import style0 from "./RoomScreen.vue?vue&type=style&index=0&id=7b40648e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b40648e",
  null
  
)

component.options.__file = "RoomScreen.vue"
export default component.exports